export default __webpack_public_path__ + "static/media/OKTIO_template_supplier.cc35c889.csv";